import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@pfida-finance/ui/components';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function RestartInfoModal({ open, onOpenChange }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-[#4b3e6d]">Rejoining the queue</DialogTitle>
          <DialogClose />
        </DialogHeader>
        <hr className="border-none h-px bg-gray-200 -mx-6" />
        <p className="text-sm text-gray-500 leading-relaxed pb-2">
          Give us 3 months&apos; notice when you are ready to restart.
        </p>
      </DialogContent>
    </Dialog>
  );
}
